document.addEventListener('change', (event) => {
  if (event.target.matches('[data-addon]')) {
    const section = event.target.closest('[data-product-section]');
    section.querySelector('[data-payment]').hidden = Boolean(section.querySelector('[data-addon]:checked')) || section.querySelector('[data-add]').disabled;
    return;
  }
  if (!event.target.matches('[data-variant]')) return;
  const section = event.target.closest('[data-product-section]');
  const option = event.target.selectedOptions[0];
  const available = option.dataset.available === 'true';
  section.querySelector('[data-price]').textContent = option.dataset.price;
  const compare = section.querySelector('[data-compare]');
  compare.textContent = option.dataset.compare;
  compare.hidden = !option.dataset.compare;
  const button = section.querySelector('[data-add]');
  button.disabled = !available;
  button.textContent = available ? 'Add to cart' : 'Sold out';
  section.querySelector('[data-payment]').hidden = !available || Boolean(section.querySelector('[data-addon]:checked'));
  const quantity = section.querySelector('[name="quantity"]');
  quantity.min = option.dataset.min;
  quantity.step = option.dataset.step;
  if (option.dataset.max) quantity.max = option.dataset.max;
  else quantity.removeAttribute('max');
  quantity.value = option.dataset.min;
});

document.addEventListener('submit', async (event) => {
  const form = event.target;
  const section = form.closest('[data-product-section]');
  if (!section) return;
  const extras = [...form.querySelectorAll('[data-addon]:checked')];
  if (!extras.length) return;
  event.preventDefault();
  const button = section.querySelector('[data-add]');
  if (button.disabled) return;
  button.disabled = true;
  const error = section.querySelector('[data-cart-error]');
  error.hidden = true;
  const data = new FormData(form);
  const items = [{ id: data.get('id'), quantity: Number(data.get('quantity')) }, ...extras.map(input => ({ id: input.value, quantity: 1 }))];
  try {
    const response = await fetch(form.action + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to add these items. Please try again.');
    location.assign(section.dataset.cartUrl);
  } catch (failure) {
    error.textContent = failure.message || 'Unable to add these items. Please try again.';
    error.hidden = false;
    button.disabled = false;
  }
});
